import React from "react"
import PropTypes from "prop-types"

const Share = props => {
  const { color, width, height, ...other } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <rect
        id="Rectangle_487"
        width="26"
        height="26"
        rx="2"
        fill={color}
        opacity="0"
      />
      <g id="target-blank" transform="translate(3.545 3.545)">
        <rect id="bound" width="18.425" height="18.908" fill="none" />
        <path
          id="Path-57"
          d="M8.833,2a.788.788,0,0,1,0,1.576H5.071A1.556,1.556,0,0,0,3.535,5.151v9.454a1.556,1.556,0,0,0,1.535,1.576h9.212a1.556,1.556,0,0,0,1.535-1.576V13.03a.768.768,0,1,1,1.535,0v1.576a3.112,3.112,0,0,1-3.071,3.151H5.071A3.112,3.112,0,0,1,2,14.606V5.151A3.112,3.112,0,0,1,5.071,2Z"
          transform="translate(-0.465 -0.424)"
          fill={color}
          opacity="0.3"
        />
        <g id="Group_3257" transform="translate(6.81 7.846) rotate(-45)">
          <path
            id="Rectangle"
            d="M.768,0a.8.8,0,0,1,.788.788l.1,7.778a.754.754,0,0,1-.768.768A.8.8,0,0,1,.1,8.546L0,.768A.754.754,0,0,1,.768,0Z"
            transform="translate(9.333 2.323) rotate(90)"
            fill={color}
          />
          <path
            id="Path-104"
            d="M4.887.281A.778.778,0,0,1,5.987.3.778.778,0,0,1,6,1.4L3.7,3.7a.778.778,0,0,1-1.1-.014L.235,1.321A.778.778,0,0,1,.221.221a.778.778,0,0,1,1.1.014L3.127,2.041Z"
            transform="translate(6.97 6.222) rotate(-90)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  )
}

Share.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

Share.defaultProps = {
  color: "#FFFFFF",
  width: 26,
  height: 26,
}

export default Share
